import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, ViewChild} from '@angular/core';
import { WeatherTimeComponent } from '../weather-time/weather-time.component';
import { MessageComponent } from '../message/message.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { VideoService } from '../../../shared/services/video.service';

@Component({
  selector: 'app-video',
  standalone: true,
  imports: [NgFor, NgIf, WeatherTimeComponent, NgClass, MessageComponent],
  templateUrl: './video.component.html'
})
export class VideoComponent {

  @ViewChild('videoPlayer')
  public videoPlayer!: ElementRef;

  public videos: any[] = [];
  public currentVideoIndex: number = 0;
  public currentLengthVideos: number = 0;

  private _slug: any;
  private _subscription: Subscription = new Subscription();

  constructor(private _videoService: VideoService<any>,
              private _route: ActivatedRoute,
              private _cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._getSlugParam();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public toggleVideo() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  public playVideo() {
    const video: HTMLVideoElement = this.videoPlayer.nativeElement;
    video.play();
  }

  public onVideoEnded(): void {
    this.currentVideoIndex++;
  
    if (this.currentVideoIndex >= this.videos.length) {
      this.currentVideoIndex = 0;
    }
  }

  private async _getSlugParam(): Promise<void> {
    this._slug = this._route.snapshot.paramMap.get('id');

    if (this._slug) {
      this._getVideos();
    }
  }

  private async _getVideos(): Promise<void> {
    this._subscription.add(this._videoService.listFiltered('slug', this._slug, '==').subscribe(videos => {
      if (videos.length > 0) {
        if (this.currentLengthVideos !== videos.length) {
          this.videos = videos;
          this._validateVideoPlayer();
        }
        
        this._cdr.markForCheck();
      }
    }));
  }

  private _validateVideoPlayer(): void {
    const intervalId = setInterval(() => {
      if (this.videoPlayer) {
        clearInterval(intervalId);
        this.playVideo();
      }
    }, 100);
  }
}
